<!--修改钱包提现密码-->
<template>
    <el-form ref="form" label-width="140px" size="mini">
        <el-tabs v-model="activeTab">
            <el-tab-pane :label="msg('提现密码')" name="withdraw">
                <el-row>
                    <el-col :xs="20" :sm="20" v-if="withdrawType==2">
                        <el-form-item :label="msg('旧提现密码')">
                            <el-input v-model.trim="oldPwd" type="password" show-password :placeholder="msg('输入旧提现密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item :label="msg('提现密码')">
                            <el-input v-model.trim="password" type="password" show-password :placeholder="msg('输入提现密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item :label="msg('确认提现密码')">
                            <el-input v-model.trim="rePassword" type="password" show-password :placeholder="msg('输入提现密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item class="wallet-hint-item">
                            <el-tag type="danger">{{msg("提示：请妥善保管提现密码，提现必须使用密码才能提现")}}</el-tag>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane :label="msg('查看钱包密码')" name="wallet">
                <el-row>
                    <el-col :xs="20" :sm="20" v-if="walletType==2">
                        <el-form-item :label="msg('旧查看钱包密码')">
                            <el-input v-model.trim="oldWalletPwd" type="password" show-password :placeholder="msg('输入旧查看钱包密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item :label="msg('查看钱包密码')">
                            <el-input v-model.trim="walletPassword" type="password" show-password :placeholder="msg('输入查看钱包密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item :label="msg('确认查看钱包密码')">
                            <el-input v-model.trim="reWalletPassword" type="password" show-password :placeholder="msg('输入查看钱包密码')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="20" :sm="20">
                        <el-form-item class="wallet-hint-item1">
                            <el-tag type="danger">{{msg("提示：查看钱包密码为打开钱包的密码，可自行选择是否设置查看钱包密码")}}</el-tag>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定')}}</span></el-button>
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        </div>
    </el-form>
</template>

<script>
export default {
    name: 'companyUpdate',
    data(){
        return {
            activeTab:'withdraw',
            oldPwd:null,
            password:null,
            rePassword:null,
            oldWalletPwd:null,
            walletPassword:null,
            reWalletPassword:null,
        }
    },
    mounted(){
    },
    props:{
        id:Number,
        withdrawType: Number, //1-设置，2-修改
        walletType: Number //1-设置，2-修改
    },
    methods:{
        init(){
            this.activeTab = 'withdraw';
            this.oldPwd = null;
            this.password = null;
            this.rePassword = null;
            this.oldWalletPwd = null;
            this.walletPassword = null;
            this.reWalletPassword = null;
        },
        onSubmit(){
            if(this.activeTab === 'withdraw'){
                if(!this.password){
                    this.$message(this.msg("请输入提现密码"));
                    return;
                }
                if(!this.rePassword){
                    this.$message(this.msg("请输入确认提现密码"));
                    return;
                }
                if(this.password != this.rePassword){
                    this.$message(this.msg("两次输入的提现密码不一致，请重新输入"));
                    return;
                }
                if(this.withdrawType == 2 && !this.oldPwd){
                    this.$message(this.msg("请输入旧提现密码"));
                    return;
                }
            }else{
                if(!this.walletPassword){
                    this.$message(this.msg("请输入钱包密码"));
                    return;
                }
                if(!this.reWalletPassword){
                    this.$message(this.msg("请输入确认钱包密码"));
                    return;
                }
                if(this.walletPassword != this.reWalletPassword){
                    this.$message(this.msg("两次输入的钱包密码不一致，请重新输入"));
                    return;
                }
                if(this.walletType == 2 && !this.oldWalletPwd){
                    this.$message(this.msg("请输入旧钱包密码"));
                    return;
                }
            }

            this.$prompt("请输入系统登录密码", this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                inputType: 'password',
            }).then(({ value }) => {
                this.$axios.post(this.$kit.api.wallet.checkLoginPwd+"?pad="+encodeURIComponent(value))
                    .then((result) => {
                        if(result.status){
                            this.doUpdate();
                        }else{
                            this.$message(this.msg('登录密码不正确'));
                        }
                    });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });

        },
        doUpdate(){
            let param = {
                id:this.id,
                password:this.activeTab === 'withdraw' ? this.password : null,
                oldPwd:this.activeTab === 'withdraw' ? this.oldPwd : null,
                walletPassword:this.activeTab === 'wallet' ? this.walletPassword : null,
                oldWalletPwd:this.activeTab === 'wallet' ? this.oldWalletPwd : null
            }
            var _this = this;
            const type = this.activeTab === 'withdraw' ? this.withdrawType : this.walletType;
            this.$axios.post(this.$kit.api.wallet.updateWalletPassword+"?type="+type, param)
                .then(function(result){
                    if(result.status){
                        _this.$message(result.msg || _this.msg("更新成功"));
                        if(result.status){
                            _this.$emit("close-dg", {
                                refresh: false
                            });
                        }
                    }else{
                        _this.$message(result.msg ||  _this.msg('更新失败'));
                    }
                });
        },
    }
}
</script>
<style lang="scss" scoped>
/deep/ .el-autocomplete-suggestion{
    width: auto!important;
}

/deep/ .wallet-hint-item .el-form-item__content{
    margin-left: 50px !important;
}
/deep/ .wallet-hint-item1 .el-form-item__content{
    margin-left: 20px !important;
}
</style>
